import * as SITE_ACTION from 'constant/action/site'
import { handleActions } from 'redux-actions'

const initialState = {
  allSites: [],
  pagination: {},
  possibleSites: [],
  showFooter: true,
  site: null
}

export default handleActions(
  {
    [SITE_ACTION.SET_ALL_SITES]: (state, action) => ({
      ...state,
      allSites: action.payload
    }),
    [SITE_ACTION.SET_SITE]: (state, action) => ({
      ...state,
      site: action.payload
    }),
    [SITE_ACTION.SET_POSSIBLE_SITES]: (state, action) => ({
      ...state,
      possibleSites: action.payload
    }),
    [SITE_ACTION.UPDATE_SITES_PAGINATION]: (state, action) => ({
      ...state,
      pagination: action.payload
    }),
    [SITE_ACTION.UPDATE_SHOW_FOOTER]: (state, action) => ({
      ...state,
      showFooter: action.payload
    })
  },
  initialState
)
